import { Component, Inject } from '@angular/core';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatActionList, MatListItem } from '@angular/material/list';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CommodityService } from '../../../data/commodity.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { Commodity } from '../../../models/commodity';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, startWith, switchMap, tap } from 'rxjs/operators';
import { emptyPage } from '../../../constants/empty-page';
import {
    shipmentEditorAddCommodityFromTemplate,
    shipmentEditorAddEmptyCommodity
} from '../../../store/shipment-editor/shipment-editor.actions';
import { MoneyPipe } from '../../shared/pipes/money.pipe';

@Component({
    selector: 'app-commodity-select',
    imports: [
    MatFormField,
    MatLabel,
    MatSuffix,
    AsyncPipe,
    IconComponent,
    MatActionList,
    MatListItem,
    ReactiveFormsModule,
    MatInput,
    MoneyPipe
],
    templateUrl: './commodity-select.component.html',
    styleUrl: './commodity-select.component.scss'
})
export class CommoditySelectComponent {
    public searchControl = new FormControl('');
    public searchActive$ = new BehaviorSubject<boolean>(true);

    constructor(@Inject(MAT_DIALOG_DATA) private data: { packageIndex: number }, private dialogRef: MatDialogRef<CommoditySelectComponent>,
                private snackBar: MatSnackBar, private commodityService: CommodityService, private store: Store<AppState>) {
    }

    public filteredCommodities$: Observable<Commodity[]> = this.searchControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(term => term.length > 2),
        startWith(''),
        tap(() => this.searchActive$.next(true)),
        switchMap(term => this.commodityService.query({ description: term }).pipe(
            finalize(() => this.searchActive$.next(false)),
            catchError(error => {
                this.snackBar.open($localize`Error searching.  Please try again.`);
                console.error(error);
                return of(emptyPage);
            })
        )),
        map(response => response.page),
    );

    selectCommodity(template: Commodity): void {
        this.store.dispatch(shipmentEditorAddCommodityFromTemplate({ packageIndex: this.data.packageIndex, template }));
        this.dialogRef.close();
    }

    newCommodity(): void {
        this.store.dispatch(shipmentEditorAddEmptyCommodity({ packageIndex: this.data.packageIndex }));
        this.dialogRef.close();
    }
}
